<template>
  <Transition name="activity-loader">
    <div
      v-if="isActive"
      class="activity-loader-backdrop"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div class="activity-loader-card">
        <span class="activity-loader-spinner" aria-hidden="true">
          <span></span>
        </span>
        <span class="activity-loader-copy">
          <strong>{{ label || "Выполняем операцию" }}</strong>
          <small>Пожалуйста, подождите</small>
        </span>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  computed: {
    isActive() {
      return this.$store.getters.isUiActivity;
    },
    label() {
      return this.$store.getters.uiActivityLabel;
    },
  },
};
</script>